"use client";

import { FilterTrueFalseAutoupdate } from "./filter-true-false-autoupdate";
import { FilterTrueFalseForm } from "./filter-true-false-form";
import {
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";

type FilterTrueFalseRequired = {
  label: string;
};

type FilterTrueFalseConditional<T extends FieldValues> =
  | { asForm: true; form: UseFormReturn<T, any, T>; paramName: Path<T> }
  | { asForm?: false; form?: never; paramName: string };

type FilterTrueFalseProps<T extends FieldValues> = FilterTrueFalseRequired &
  FilterTrueFalseConditional<T>;

export const FilterTrueFalse = <T extends FieldValues>({
  asForm = false,
  form,
  label,
  paramName,
}: FilterTrueFalseProps<T>) => {
  if (asForm && form && paramName) {
    return (
      <FilterTrueFalseForm paramName={paramName} label={label} form={form} />
    );
  }

  return <FilterTrueFalseAutoupdate paramName={paramName} label={label} />;
};
